import { createSlice,PayloadAction } from '@reduxjs/toolkit';
import { login, logout } from './authSlice';

interface RightSideAdState {
  isVisible: boolean | null;
  adComponent: number;
  // Single source for the bottom advertisement (Subjects and MyLibrary); false once the user closes it
  showBottomAd: boolean;
}
//initial state for rightSideAd
const initialState: RightSideAdState = {
    isVisible: false,
    adComponent: 0,
    showBottomAd: true
};

const rightSideAdSlice = createSlice({
  name: 'rightSideAd',
  initialState,
  reducers: {
    visibility(state,action: PayloadAction<{isVisible: boolean}>) {
      state.isVisible = action.payload.isVisible;
    },
    changeAdComponent(componentName,action: PayloadAction<{adComponent: number}>){
      componentName.adComponent = action.payload.adComponent;
    },
    closeBottomAd(state) {
      state.showBottomAd = false;
    }
  },
  // Reset on logout and on login so a new session (even without a page refresh) starts with the ads visible,
  // and never inherits the previous user's closed/hidden ad state. Login covers expired sessions that skip logout.
  extraReducers: (builder) => {
    builder
      .addCase(logout, () => initialState)
      .addCase(login, () => initialState);
  },
});

export const { visibility, changeAdComponent, closeBottomAd } = rightSideAdSlice.actions;
export default rightSideAdSlice.reducer;
